import { Box, Typography } from '@mui/material';
import InteractiveDiagramCanvas from './InteractiveDiagramCanvas';
import { interactiveRevealValue } from '../utils/interactiveRevealValue';
import { interactiveReviewValueOf } from '../utils/interactiveAnswerValue';

/**
 * The student's plotted shape beside the correct one, for an interactive drawing answer.
 * Shared by the mock-exam Review and Report so a drawing reads the same on both.
 */
const InteractiveAnswerBlock = ({ row }) => {
  const correct = row?.correct_interactive || null;
  const gridSpec = row?.answer_data?.interactive || correct;
  // Edges-only ("join the printed corners"), lines-with-none and cut-drag answers are objects with no
  // point array, so an Array.isArray test rendered the student's own drawing as "—".
  const your = interactiveReviewValueOf(row?.your_answer_interactive, gridSpec || correct);
  const drawingUrl = row?.submitted_drawing || row?.your_answer_drawing || null;
  if (!correct && !gridSpec && !drawingUrl) return null;
  return (
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', my: 1 }}>
      <Box sx={{ flex: 1, minWidth: 220 }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, display: 'block', mb: 0.5 }}>Your shape</Typography>
        {your && gridSpec ? (
          <InteractiveDiagramCanvas spec={gridSpec} imageUrl={gridSpec.image_url || row.image_url || ''} readOnly value={your} />
        ) : drawingUrl ? (
          <Box
            component="img"
            src={drawingUrl}
            alt="Your drawing"
            sx={{ maxWidth: '100%', maxHeight: 280, border: '1px solid #e0e0e0', borderRadius: 1, display: 'block', bgcolor: 'white' }}
          />
        ) : (
          <Typography variant="body2" color="text.disabled">—</Typography>
        )}
      </Box>
      {correct && (
        <Box sx={{ flex: 1, minWidth: 220 }}>
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, display: 'block', mb: 0.5 }}>Correct shape</Typography>
          <InteractiveDiagramCanvas spec={correct} imageUrl={correct.image_url || row.image_url || ''} readOnly revealValue={interactiveRevealValue(correct)} />
        </Box>
      )}
    </Box>
  );
};

export default InteractiveAnswerBlock;
